import * as swcHelpers from '@swc/helpers';

var isNoRxCLPrescription = ({ allAttributesAreFilledIn , rxAttributeDefaults  })=>{
    if (!allAttributesAreFilledIn || rxAttributeDefaults.power !== '0.00') {
        return false;
    }
    const restRxCLPrescriptionValues = swcHelpers.objectWithoutProperties(rxAttributeDefaults, [
        "power",
        "baseCurve",
        "diameter"
    ]);
    // Check if the lens has any other Rx values besides power, base curve and diameter
    if (Object.values(restRxCLPrescriptionValues).some(Boolean)) {
        return false;
    }
    return true;
};

export { isNoRxCLPrescription };
//# sourceMappingURL=is-no-rx-cl-prescription.js.map
